import React from 'react';
import { useScopedI18n } from '@locales/client';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { TimerContainer,TimerIcon, TimeValue  } from './styles';
import { useGoldCardTimer, useGoldCard } from '@/shared/providers/notifications-provider/store';
import { useGameIdentification } from '@/features/gold-card/model/hooks/useGameIdentification';
import { useFormatTime } from '@/features/gold-card/model/hooks/useFormatTime';

export const BonusTimer: React.FC = () => {
  const goldCardTimer = useGoldCardTimer();
  const goldCard = useGoldCard();
  const { countdownFormattedTime, isValidTime, isFinished } = useFormatTime(goldCardTimer?.time || goldCard?.time);
  const { isActiveGame } = useGameIdentification(goldCardTimer || goldCard )
  const tBonus = useScopedI18n('common.filter.category');

  if (!isActiveGame || !isValidTime || isFinished) {
    return null;
  }

  return (
    <TimerContainer>
        <BodyTextMediumC>{tBonus('bonus')}</BodyTextMediumC>
        <TimerIcon src='/images/icons/clock-wallet.svg'/>
        <TimeValue>{countdownFormattedTime}</TimeValue>
    </TimerContainer>
  );
};